export default __webpack_public_path__ + "static/media/melih1.93cc4ba8.png";